import {SnackCmp} from "../../../component/snack.cmp";
import {Grid, GridItem} from "@consta/uikit/Grid";
import {Combobox} from "@consta/uikit/Combobox";
import {TextField} from "@consta/uikit/TextField";
import React, {useEffect, useState} from "react";
import {Attachment} from '@consta/uikit/Attachment';
import '../../css/pageBsi.css';
import axios from "axios";
import {
    API_BSI_PAYLOAD,
    API_BSI_PROCESSING,
    API_BSI_SIZE_CHECK, API_EQUIPAGE_FOR_UPLOAD,
    API_EQUIPAGE_LIST,
    API_URL_DICT
} from "../../../service/api.endpoint";
import {company} from "../../../component/header.cmp";
import moment from "moment/moment";
import {IconTrash} from "@consta/uikit/IconTrash";
import {v4 as uuidv4} from 'uuid';
import cookieCmp from '../../../component/cookie.cmp';
import {SnackBarItemStatus} from "@consta/uikit/SnackBar";
import * as S from "./modal.bsi.payload.styled";


const username = localStorage.getItem('username')
type SkkNameType = "CKK-Tehno" | "Nedrakam" | 'noname'


export type Item = {
    label: string;
    id: string;
};

export type ProcessingType = {
    data: string;
    equipage: string;
    fio: string;
    status: SnackBarItemStatus
};

type DictType = {
    pk: string,
    name: string,
    comment: { name: string, pk: string }[],
    level: { name: string, pk: string }[],
    equipage: { name: string, pk: string }[],
}

interface ModalComponentProps {
    isOpen: boolean;
    onClose: any;
    nodeData: any
    files: any
}

// Получение CSRF токена из cookies
const csrftoken = cookieCmp('csrftoken');

// Установка CSRF токена в заголовок запроса
axios.defaults.headers.post['X-CSRFToken'] = csrftoken;

// проверка на изменение файла
function checkLastModify(contents: any, lastModify: string, skkName: SkkNameType) {
    console.log(contents)
    if (skkName === 'CKK-Tehno') {
        for (let i = 1; i <= 5; i++) {
            try {
                const firstLine = contents.split('\n')[0];
                const lastStringDate = moment(contents.split('\n').slice(-i)[0], 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');
                if (moment(lastModify, 'DD.MM.YYYY') < moment('01.01.2020', 'DD.MM.YYYY')) {
                    return true;
                } else if (['458', '550', '520', '521', '558', '565', '566', '571', '572', '573'].some(code => firstLine.includes(code))) {
                    return true;
                } else {
                    const isModify = lastModify === lastStringDate;
                    if (isModify) {
                        return true;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
        return false;
    } else if (skkName === 'Nedrakam') {
        return true
    } else if (contents.includes('SK-SPO-2')) {
        return true
    }
    return false
}

function lastStringDate(contents: any) {
    for (let i = 1; i <= 5; i++) {
        try {
            const lst = moment(contents.split('\n').slice(-i)[0], 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');
            if (lst && lst !== 'Invalid date') {
                return lst
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const readFile = (file: any) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const contents = reader.result;
            resolve(contents);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsText(file);
    });
};

const ModalBsiPayload: React.FC<ModalComponentProps> = ({files, isOpen, onClose}) => {

    const [bsiFiles, setBsiFiles] = useState<File[]>([]);
    const [isSaving, setIsSaving] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [fileStatuses, setFileStatuses] = useState<Array<'pending' | 'processing' | 'success' | 'error'>>([]);

    const [itemsEquipage, setItemsEquipage] = useState<Item[]>([]);
    const [isAlert, setIsAlert] = useState<boolean>(false)

    const [valueEquipage, setValueEquipage] = useState(Array(bsiFiles.length).fill(''));
    const [valueFIO, setValueFIO] = useState(Array(bsiFiles.length).fill(''));
    const [lastString, setLastString] = useState(Array(bsiFiles.length).fill(''));
    const [skkName, setSkkName] = useState(Array(bsiFiles.length).fill(''));
    const [bsiFileSize, setBsiFileSize] = useState(Array(bsiFiles.length).fill(''));
    const [bsiFileContent, setBsiFileContent] = useState<string[]>(Array(bsiFiles.length).fill(''));
    const [bsiDate, setBsiDate] = useState<string[]>(Array(bsiFiles.length).fill(''));
    const [processingData, setProcessingData] = useState<ProcessingType[]>([])
    const [isFinalProcessing, setIsFinalProcessing] = useState<boolean>(false)

    const resetAllState = () => {
        setBsiFiles([]);
        setValueEquipage([]);
        setValueFIO([]);
        setLastString([]);
        setSkkName([]);
        setBsiFileSize([]);
        setBsiFileContent([]);
        setBsiDate([]);
        setFileStatuses([]);
        setIsSaving(false);
        setUploadProgress(0);
        setCurrentFileIndex(0);
        setProcessingData([]);
        setIsFinalProcessing(false);
        setIsAlert(false);
    };
    const handleDeleteFile = (index: number) => {
        const newBsiFiles = [...bsiFiles];
        newBsiFiles.splice(index, 1);
        setBsiFiles(newBsiFiles);

        const newValueEquipage = [...valueEquipage];
        newValueEquipage.splice(index, 1);
        setValueEquipage(newValueEquipage);

        const newValueFIO = [...valueFIO];
        newValueFIO.splice(index, 1);
        setValueFIO(newValueFIO);

        const newLastString = [...lastString];
        newLastString.splice(index, 1);
        setLastString(newLastString);

        const newSkkName = [...skkName];
        newSkkName.splice(index, 1);
        setSkkName(newSkkName);

        const newBsiFileSize = [...bsiFileSize];
        newBsiFileSize.splice(index, 1);
        setBsiFileSize(newBsiFileSize);

        const newBsiFileContent = [...bsiFileContent];
        newBsiFileContent.splice(index, 1);
        setBsiFileContent(newBsiFileContent);

        const newBsiDate = [...bsiDate];
        newBsiDate.splice(index, 1);
        setBsiDate(newBsiDate);

        const newFileStatuses = [...fileStatuses];
        newFileStatuses.splice(index, 1);
        setFileStatuses(newFileStatuses);
    };

    const handleSaveButton = async () => {
        const hasErrors = bsiFileContent.some(msg =>
                msg && (
                    msg.includes("уже был загружен") ||
                    msg.includes("ИЗМЕНЕН") ||
                    msg.includes("поврежден") ||
                    msg.includes("Empty File")
                )
        );
        if (hasErrors) {
            setIsAlert(true);
            // можно вывести SnackBar с предупреждением
            return;
        }
        setIsSaving(true);
        setProcessingData([])
        setUploadProgress(0);
        setFileStatuses(Array(bsiFiles.length).fill('pending'));

        try {
            // 1. Формируем массив с явной типизацией
            type FileWithDate = {
                file: File;
                dateString: string;
            };

            const mergedArraysBsi: FileWithDate[] = bsiFiles.map((file, index) => ({
                file,
                dateString: lastString[index] || "",
            }));

            // 2. Сортировка (без any)
            mergedArraysBsi.sort((a, b) => {
                const dateA = new Date(a.dateString);
                const dateB = new Date(b.dateString);
                return dateA.getTime() - dateB.getTime();
            });

            const totalFiles = mergedArraysBsi.length;
            let i = 0

            for (const {file, dateString} of mergedArraysBsi) {
                const fileIndex = bsiFiles.findIndex((f: File) => f.name === file.name);

                setCurrentFileIndex(fileIndex);
                setFileStatuses(prev => {
                    const newStatuses = [...prev];
                    newStatuses[fileIndex] = 'processing';
                    return newStatuses;
                });

                try {
                    const formData = new FormData();
                    const uuid = uuidv4();
                    formData.append('id', uuid);
                    formData.append('bsi_file', file, `${uuid}.txt`);
                    formData.append('date', bsiDate[fileIndex]);
                    formData.append('equipage', valueEquipage[fileIndex].id);
                    company && formData.append('org', company);
                    formData.append('fio', valueFIO[fileIndex]);
                    formData.append('file_size', bsiFileSize[fileIndex]);
                    formData.append('last_string_date', lastString[fileIndex]);
                    // @ts-ignore
                    formData.append('username', username);

                    const payloadResult = await axios.post(API_BSI_PAYLOAD, formData, {
                        headers: {
                            'X-CSRFToken': csrftoken
                        }
                    });

                    if (payloadResult.status === 201) {
                        const newData: ProcessingType = {
                            equipage: valueEquipage[fileIndex].label,
                            data: bsiDate[fileIndex],
                            fio: valueFIO[fileIndex],
                            status: 'normal'
                        };
                        try {
                            await axios.post(API_BSI_PROCESSING, {
                                params: {
                                    equipage: valueEquipage[fileIndex].id,
                                    org: company,
                                    date: bsiDate[fileIndex],
                                    skk_name: skkName[fileIndex]
                                }
                            }, {
                                headers: {
                                    'X-CSRFToken': csrftoken
                                }
                            });
                            newData['status'] = 'success'
                            setProcessingData(prevData => [...prevData, newData]);

                            setFileStatuses(prev => {
                                const newStatuses = [...prev];
                                newStatuses[fileIndex] = 'success';
                                return newStatuses;
                            });
                        } catch (error) {
                            newData['status'] = 'alert'
                            setProcessingData(prevData => [...prevData, newData]);

                            setFileStatuses(prev => {
                                const newStatuses = [...prev];
                                newStatuses[fileIndex] = 'error';
                                return newStatuses;
                            });
                        }
                    }
                    i = i + 1
                    setUploadProgress(Math.round((i / totalFiles) * 100));
                } catch (error) {
                    setFileStatuses(prev => {
                        const newStatuses = [...prev];
                        newStatuses[fileIndex] = 'error';
                        return newStatuses;
                    });
                    i = i + 1
                    setUploadProgress(Math.round((i / totalFiles) * 100));
                }
            }

            onClose(processingData);
            resetAllState();
        } catch (error) {
            setIsAlert(true);
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        setIsAlert(true);
        setIsFinalProcessing(false)
    }, [isFinalProcessing]);

    useEffect(() => {
        setBsiFiles(files)
    }, [files]);

    function bsiCheck(repeatData: [], isModify: boolean) {
        if (repeatData.length > 0) {
            return "Этот файл уже был загружен!"
        } else if (!isModify) {
            return "БСИ-ФАЙЛ ИЗМЕНЕН!"
        } else {
            return undefined
        }
    }

    useEffect(() => {
        bsiFiles.forEach((file: any, index) => {
                if (file) {
                    readFile(file)
                        .then(async (contents: any) => {
                                let SKK: SkkNameType = 'noname'
                                let dateElement: number = 6
                                let dataString;
                                try {
                                    const isSKKNedrakam = (contents: string) => {
                                        const lines = contents.split('\n');
                                        const fourthLine = lines[4];
                                        const bsiCodes = ['670', '841', '591', '824', '655', '846', '444', '445', '843', '1057'];
                                        return bsiCodes.some(code => fourthLine.includes(code));
                                    };

                                    if (contents.split('\n')[0].includes("Tehno")) {
                                        SKK = "CKK-Tehno"
                                        dateElement = 3
                                    } else if (isSKKNedrakam(contents)) {
                                        SKK = "Nedrakam"
                                        dateElement = 5
                                    }

                                    dataString = contents.split('\n')[dateElement];
                                    const fileDate = moment(dataString.split(' ')[0], 'DD.MM.YYYY').format('YYYY-MM-DD');
                                    const lastModify = moment(file.lastModifiedDate, 'DD.MM.YYYY HH:mm').format('DD.MM.YYYY HH:mm:ss')

                                    const isModify: boolean = checkLastModify(contents, lastModify, SKK);
                                    if (file.size < 4000) {
                                        throw new Error("Empty File");
                                    }

                                    axios.get(API_BSI_SIZE_CHECK, {params: {day: fileDate, file_size: file.size}})
                                        .then((response) => {
                                            const repeatData: [] = response.data;
                                            setBsiFileContent(prevContent => {
                                                const updatedContent: any = [...prevContent];
                                                updatedContent[index] = bsiCheck(repeatData, isModify);
                                                return updatedContent;
                                            });
                                        });

                                    setBsiDate(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = fileDate;
                                        return updatedContent;
                                    });
                                    setBsiFileSize(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = file.size
                                        return updatedContent;
                                    });
                                    setLastString(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = lastStringDate(contents)
                                        return updatedContent;
                                    });
                                    setSkkName(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = SKK
                                        return updatedContent;
                                    });

                                } catch (error) {
                                    setBsiFileContent(prevContent => {
                                        const updatedContent = [...prevContent];
                                        updatedContent[index] = 'Нет данных или файл БСИ поврежден!';
                                        return updatedContent;
                                    });
                                    dataString = ''
                                }
                            }
                        )
                        .catch((error) => {
                            console.error('Ошибка чтения файла:', error);
                        });
                }
            }
        )
    }, [bsiFiles]);

    useEffect(() => {
        if (bsiFileContent.filter(item => item !== undefined).length > 0) {
            setIsSaving(true)
        } else {
            if (bsiFiles.length ===
                valueEquipage.filter(item => item !== undefined).filter(item => item !== null).length) {
                setIsSaving(false)
            } else {
                setIsSaving(true)
            }
        }
    }, [bsiFileContent, bsiFiles, valueEquipage]);

    useEffect(() => {
        setIsAlert(false)
        setProcessingData([])

        const fetchData = async () => {
            try {
                const response = await axios.get(API_EQUIPAGE_LIST, {
                    params: {
                        company: company,
                        is_for_upload: true
                    }
                });
                setItemsEquipage(response.data);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();

    }, [company])

    return (
        <>
            {(isAlert) &&
                <SnackCmp alertText={''} processingData={processingData} alertType={'normal'}/>}

            <S.StyledModal
                className="modal_bsi"
                isOpen={isOpen}
                hasOverlay
                onEsc={() => {
                    if (!isSaving && !fileStatuses.some(status => status === 'processing')) {
                        resetAllState();
                        onClose(false);
                    }
                }}
            >
                <S.ModalContainer>
                    <S.ModalHeader>
                        <S.ModalTitle>Загрузка файлов БСИ</S.ModalTitle>
                        <S.ModalSubtitle>
                            Выберите экипаж и укажите ФИО ответственного для каждого файла
                        </S.ModalSubtitle>
                    </S.ModalHeader>


                    <Grid cols="3" gap="xs">
                        {bsiFiles.map((file: File, index: number) => {
                            return (
                                <React.Fragment key={`key_${index}`}>
                                    <GridItem col={'3'} key={`grid_full_${index}`}>
                                        <S.FileCard>
                                            <Grid cols="3" gap="xs">
                                                <GridItem col={'1'} key={`grid1_${index}`}>
                                                    <Attachment
                                                        key={`attach_${index}`}
                                                        fileName={file.name}
                                                        fileExtension="txt"
                                                        fileDescription={`${Math.round(file.size / 1000)} КБ ${moment(file.lastModified).format('DD.MM.YYYY, HH:mm')}`}
                                                        errorText={bsiFileContent[index]}           // ← остаётся для ошибок валидации
                                                    />
                                                    {fileStatuses[index] && (
                                                        <S.FileStatus status={fileStatuses[index]}>
                                                            {fileStatuses[index] === 'pending' && '⏳ Ожидание'}
                                                            {fileStatuses[index] === 'processing' && '⚙️ Обработка...'}
                                                            {fileStatuses[index] === 'success' && '✓ Успешно загружен'}
                                                            {fileStatuses[index] === 'error' && '✗ Ошибка'}
                                                        </S.FileStatus>
                                                    )}
                                                    {fileStatuses[index] === 'processing' && (
                                                        <S.ProgressBarContainer>
                                                            <S.ProgressBarWrapper>
                                                                <S.ProgressBarFill progress={uploadProgress}/>
                                                            </S.ProgressBarWrapper>
                                                            <S.ProgressText>
                                                                <S.ProgressLabel>
                                                                    Обработка файлов...
                                                                </S.ProgressLabel>
                                                                <span>{uploadProgress}%</span>
                                                            </S.ProgressText>
                                                            <S.ProgressText style={{
                                                                fontSize: '12px',
                                                                color: '#718096',
                                                                marginTop: '4px'
                                                            }}>
                                                                <span>Файл {currentFileIndex + 1} из {bsiFiles.length}</span>
                                                            </S.ProgressText>
                                                        </S.ProgressBarContainer>
                                                    )}
                                                </GridItem>
                                                <GridItem col={'1'} key={`grid2_${index}`}>
                                                    <Combobox
                                                        key={`equipage_${index}`}
                                                        items={itemsEquipage}
                                                        value={valueEquipage[index]}
                                                        onChange={({value}) => {
                                                            const updatedValueEquipage = [...valueEquipage];
                                                            updatedValueEquipage[index] = value;
                                                            setValueEquipage(updatedValueEquipage);
                                                        }}
                                                        placeholder="Экипаж"
                                                        required={true}
                                                        disabled={fileStatuses[index] === 'processing' ||
                                                            fileStatuses[index] === 'pending' ||
                                                            fileStatuses[index] === 'success'}
                                                    />
                                                </GridItem>
                                                <GridItem key={`grid3_${index}`}>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <TextField
                                                            key={`fio_${index}`}
                                                            id={`fioID_${index}`}
                                                            style={{width: '100%'}}
                                                            value={valueFIO[index]}
                                                            onChange={({value}) => {
                                                                const updatedValueFIO = [...valueFIO];
                                                                updatedValueFIO[index] = value;
                                                                setValueFIO(updatedValueFIO);
                                                            }}
                                                            type="text"
                                                            placeholder="Укажите ФИО"
                                                            autoComplete='on'
                                                            required={true}
                                                            disabled={fileStatuses[index] === 'processing' ||
                                                                fileStatuses[index] === 'pending' ||
                                                                fileStatuses[index] === 'success'}
                                                        />
                                                        <IconTrash
                                                            key={`trash_${index}`}
                                                            className="iconTrash"
                                                            onClick={() => {
                                                                if (!(fileStatuses[index] === 'processing' ||
                                                                    fileStatuses[index] === 'pending' ||
                                                                    fileStatuses[index] === 'success')) {
                                                                    handleDeleteFile(index);
                                                                }
                                                            }}
                                                            style={{
                                                                opacity: (fileStatuses[index] === 'processing' ||
                                                                    fileStatuses[index] === 'pending' ||
                                                                    fileStatuses[index] === 'success') ? 0.5 : 1,
                                                                cursor: (
                                                                    fileStatuses[index] === 'processing' ||
                                                                    fileStatuses[index] === 'pending' ||
                                                                    fileStatuses[index] === 'success'
                                                                ) ? 'not-allowed' : 'pointer'
                                                            }}
                                                        />
                                                    </div>
                                                </GridItem>
                                            </Grid>
                                        </S.FileCard>
                                    </GridItem>
                                </React.Fragment>
                            );
                        })}
                    </Grid>

                    <S.ButtonGroup>
                        <S.StyledButton
                            size="m"
                            view="primary"
                            label="Сохранить"
                            width="default"
                            onClick={() => {
                                setIsAlert(false);
                                handleSaveButton();
                            }}
                            disabled={isSaving} // Добавляем блокировку кнопки во время сохранения
                        />

                        <S.StyledButton
                            className='cancel'
                            size="m"
                            view="secondary"
                            label="Отменить"
                            width="default"
                            onClick={() => {
                                resetAllState();
                                onClose(false);
                            }}
                            disabled={fileStatuses.some(status => status === 'processing')}
                        />
                    </S.ButtonGroup>
                </S.ModalContainer>
            </S.StyledModal>
        </>
    )
};

export default ModalBsiPayload;